var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 39,
    viewBox: "0 0 32 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5821 7.56244C30.2276 6.85478 29.7255 5.71728 28.7677 5.71728L20.3366 5.71728C20.0169 5.71728 19.7129 5.85608 19.5036 6.0977L10.9603 15.9564C10.5816 16.3935 10.605 17.0489 11.0139 17.4578L15.1881 21.6319C15.6326 22.0764 16.3583 22.0598 16.7819 21.5953L29.5821 7.56244Z",
    fill: "#EEEEEE",
    stroke: "#DEDEDE",
    strokeWidth: 1.10231
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41791 7.56143C1.77242 6.85377 2.27446 5.71628 3.23229 5.71626L11.6634 5.71613C11.9831 5.71612 12.2871 5.85493 12.4965 6.09656L21.0397 15.9555C21.4184 16.3925 21.395 17.0479 20.9861 17.4568L16.8119 21.6309C16.3674 22.0755 15.6417 22.0588 15.2181 21.5944L2.41791 7.56143Z",
    fill: "#EEEEEE",
    stroke: "#DEDEDE",
    strokeWidth: 1.10231
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.7999,
    cy: 25.8749,
    r: 12.4928,
    fill: "#EEEEEE",
    stroke: "#DEDEDE",
    strokeWidth: 1.10231
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.7999,
    cy: 25.8744,
    r: 8.81845,
    fill: "#EEEEEE",
    stroke: "#DEDEDE",
    strokeWidth: 1.10231
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalBlank);
export default __webpack_public_path__ + "static/media/medal_blank.557fa004e18d912263b46d3b339bd8dd.svg";
export { ForwardRef as ReactComponent };